import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { verifyotp, sendotp, getProfile } from "../api/user";
import { toast } from "react-toastify";
import PageContainer from "../components/pages/PageContainer";

const VerificationPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [verificationCode, setVerificationCode] = useState("");
  const [containerHeight, setContainerHeight] = useState(window.innerHeight);
  const [isVerifying, setIsVerifying] = useState(false); // State to track verification process

  // const isVerified = JSON.parse(localStorage.getItem("isVerified"))

  // useEffect(() => {
  //   if (window.location.pathname === "/auth/verification" && !isVerified)
  //     toast.error("Your account is not verified!");
  // }, [isVerified])

  useEffect(() => {
    const handleResize = () => {
      setContainerHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleVerification = async () => {
    setIsVerifying(true);
    const token = localStorage.getItem("email_token");
    const body = {
      otp: verificationCode,
      token: token,
    };
    try {
      const response = await verifyotp(body);
      if (response.data.status === 200) {
        toast.success(response.data.message);
        if (response.data.status === 200) {
          localStorage.removeItem("email_token");
          localStorage.removeItem("email");
          localStorage.setItem("isVerified", true);
          await fetchProfile();
          setIsVerifying(false);
          // Function to check if userInfo is set and navigate accordingly.
          const checkAndNavigate = () => {
            if (localStorage.getItem("userInfo") !== null) {
            //  navigate("/profile");
              // Retrieve gameurl from local storage
  let savedUrl = JSON.parse(localStorage.getItem("gameurl"));

  // Replace "contests" with "contest" in the saved URL if it exists
  if (savedUrl && savedUrl.includes("/contests/")) {
    savedUrl = savedUrl.replace("/contests/", "/contest/");
  }

  // Redirect to the saved URL if it exists, otherwise go to /profile
  if (savedUrl) {
    window.location.href = savedUrl;
  } else {
    navigate("/profile");
  }
            } else {
              // If userInfo is not yet available, check again after some time.
              setTimeout(checkAndNavigate, 500); // Check every 500 milliseconds.
            }
          };

          // Start the checking process.
          checkAndNavigate();
        }
      } else if (response.data.status === 400) {
        setIsVerifying(false);
        toast.error(response.data.message);
      }
    } catch (error) {
      setIsVerifying(false);
      console.error("Error:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      const response = await getProfile();

      if (response?.data?.data) {
        localStorage.setItem("img", response?.data?.data?.image);
        localStorage.setItem("userInfo", JSON.stringify(response.data.data));
        const myCustomEvent = new CustomEvent("profileEvent", {
          detail: {
            profileImg: response?.data?.data?.image,
            profileData: response?.data?.data,
          },
        });
        window.dispatchEvent(myCustomEvent);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const resendotp = async () => {
    setIsVerifying(true);
    // localStorage.removeItem("email_token");
    try {
      const email1 = localStorage.getItem("userEmail");
      const ema = {
        email: email1,
        otp_purpose: 2,
      };

      const response = await sendotp(ema);

      if (response.data.status === 200) {
        setIsVerifying(false);
        // console.log(response);
        const newToken = response.data.data.email_token;
        toast.success(response.data.message);
        localStorage.setItem("email_token", newToken);
      } else if (response.data.status === 400) {
        setIsVerifying(false);
        toast.error(response.data.message);
      } else {
        setIsVerifying(false);
        // console.log(response);
      }
    } catch (error) {
      setIsVerifying(false);
      console.error("Error during resendotp:", error);
    }
  };

  return (
    <PageContainer>
      <div
        className="flex justify-center items-center  pt-10"
        style={{ height: `${containerHeight}px` }}
      >
        <div className="max-w-xs mx-auto p-4 rounded-lg sm:mb-24 text-center mb-48 space-y-6">
          <img src={"/qushi_logo.png"} alt="" className="mb-4 w-32 mx-auto" />
          <h1 className="text-2xl font-bold">{t("Verification")}</h1>
          <p className="text-gray-500 text-sm mt-4">
            {t(
              "Enter_the_8-digit_Crypex_security_code_and_your_phone_number_will_be_verified"
            )}
          </p>
          <p className="mt-6 ml-4 text-left text-gray-500 text-xs">
            {t("VERIFICATION_CODE")}
          </p>
          <input
            type="text"
            placeholder="Enter code"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            className="w-full px-2 py-3 mt-2 border rounded-lg pl-7 text-xs border-gray-500"
          />
          <p className="mt-2 text-gray-500 text-xs">
            {t("Don't_receive_your_code?")}
            <button
              disabled={isVerifying}
              onClick={resendotp}
              className="text-gray-600 font-bold"
            >
              {t("Resend")}
            </button>{" "}
            {t("or")}{" "}
            <button
              disabled={isVerifying}
              onClick={resendotp}
              className="text-gray-600 font-bold"
            >
              {t("Send to Email")}
            </button>
          </p>
          <div>
            <button
              type="submit"
              disabled={isVerifying}
              onClick={handleVerification}
              className="flex items-center justify-center focus:outline-none text-white text-sm bg-primaryColor mt-8 rounded-xl md:rounded-xl md:py-3 py-3 w-full"
            >
              {t("Submit")}
            </button>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default VerificationPage;
